<div class="default-container">
  <div class="headline">
    <h2>No Access</h2>
  </div>
 <mat-card>
    Unfortunately, you are not linked to any properties in the ANZCO Foods Producer Portal. If you believe this is incorrect please contact either your farm owner or the ANZCO Foods Livestock Admin on <a href="mailto:support@anzcoproducers.co.nz">support@anzcoproducers.co.nz</a>.
  <br><br>
  Kind Regards, the ANZCO Foods Livestock Team.
 </mat-card>
</div>